enum SourceType {
	git = "Git",
	gitLab = "GitLab",
	gitHub = "GitHub",
	confluenceCloud = "Confluence Cloud",
	confluenceServer = "Confluence self-hosted server",
	yandexDisk = "Yandex.Disk",
	notion = "Notion",
}

export default SourceType;
